// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v5.29.3
// source: mmtp.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "";
export var MsgType;
(function (MsgType) {
    MsgType[MsgType["UNSPECIFIED_MESSAGE"] = 0] = "UNSPECIFIED_MESSAGE";
    MsgType[MsgType["PROTOCOL_MESSAGE"] = 1] = "PROTOCOL_MESSAGE";
    MsgType[MsgType["RESPONSE_MESSAGE"] = 2] = "RESPONSE_MESSAGE";
    MsgType[MsgType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MsgType || (MsgType = {}));
export function msgTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "UNSPECIFIED_MESSAGE":
            return MsgType.UNSPECIFIED_MESSAGE;
        case 1:
        case "PROTOCOL_MESSAGE":
            return MsgType.PROTOCOL_MESSAGE;
        case 2:
        case "RESPONSE_MESSAGE":
            return MsgType.RESPONSE_MESSAGE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MsgType.UNRECOGNIZED;
    }
}
export function msgTypeToJSON(object) {
    switch (object) {
        case MsgType.UNSPECIFIED_MESSAGE:
            return "UNSPECIFIED_MESSAGE";
        case MsgType.PROTOCOL_MESSAGE:
            return "PROTOCOL_MESSAGE";
        case MsgType.RESPONSE_MESSAGE:
            return "RESPONSE_MESSAGE";
        case MsgType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
export var ProtocolMessageType;
(function (ProtocolMessageType) {
    ProtocolMessageType[ProtocolMessageType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    ProtocolMessageType[ProtocolMessageType["SUBSCRIBE_MESSAGE"] = 1] = "SUBSCRIBE_MESSAGE";
    ProtocolMessageType[ProtocolMessageType["UNSUBSCRIBE_MESSAGE"] = 2] = "UNSUBSCRIBE_MESSAGE";
    ProtocolMessageType[ProtocolMessageType["SEND_MESSAGE"] = 3] = "SEND_MESSAGE";
    ProtocolMessageType[ProtocolMessageType["RECEIVE_MESSAGE"] = 4] = "RECEIVE_MESSAGE";
    ProtocolMessageType[ProtocolMessageType["FETCH_MESSAGE"] = 5] = "FETCH_MESSAGE";
    ProtocolMessageType[ProtocolMessageType["DISCONNECT_MESSAGE"] = 6] = "DISCONNECT_MESSAGE";
    ProtocolMessageType[ProtocolMessageType["CONNECT_MESSAGE"] = 7] = "CONNECT_MESSAGE";
    ProtocolMessageType[ProtocolMessageType["NOTIFY_MESSAGE"] = 8] = "NOTIFY_MESSAGE";
    ProtocolMessageType[ProtocolMessageType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ProtocolMessageType || (ProtocolMessageType = {}));
export function protocolMessageTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "UNSPECIFIED":
            return ProtocolMessageType.UNSPECIFIED;
        case 1:
        case "SUBSCRIBE_MESSAGE":
            return ProtocolMessageType.SUBSCRIBE_MESSAGE;
        case 2:
        case "UNSUBSCRIBE_MESSAGE":
            return ProtocolMessageType.UNSUBSCRIBE_MESSAGE;
        case 3:
        case "SEND_MESSAGE":
            return ProtocolMessageType.SEND_MESSAGE;
        case 4:
        case "RECEIVE_MESSAGE":
            return ProtocolMessageType.RECEIVE_MESSAGE;
        case 5:
        case "FETCH_MESSAGE":
            return ProtocolMessageType.FETCH_MESSAGE;
        case 6:
        case "DISCONNECT_MESSAGE":
            return ProtocolMessageType.DISCONNECT_MESSAGE;
        case 7:
        case "CONNECT_MESSAGE":
            return ProtocolMessageType.CONNECT_MESSAGE;
        case 8:
        case "NOTIFY_MESSAGE":
            return ProtocolMessageType.NOTIFY_MESSAGE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ProtocolMessageType.UNRECOGNIZED;
    }
}
export function protocolMessageTypeToJSON(object) {
    switch (object) {
        case ProtocolMessageType.UNSPECIFIED:
            return "UNSPECIFIED";
        case ProtocolMessageType.SUBSCRIBE_MESSAGE:
            return "SUBSCRIBE_MESSAGE";
        case ProtocolMessageType.UNSUBSCRIBE_MESSAGE:
            return "UNSUBSCRIBE_MESSAGE";
        case ProtocolMessageType.SEND_MESSAGE:
            return "SEND_MESSAGE";
        case ProtocolMessageType.RECEIVE_MESSAGE:
            return "RECEIVE_MESSAGE";
        case ProtocolMessageType.FETCH_MESSAGE:
            return "FETCH_MESSAGE";
        case ProtocolMessageType.DISCONNECT_MESSAGE:
            return "DISCONNECT_MESSAGE";
        case ProtocolMessageType.CONNECT_MESSAGE:
            return "CONNECT_MESSAGE";
        case ProtocolMessageType.NOTIFY_MESSAGE:
            return "NOTIFY_MESSAGE";
        case ProtocolMessageType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
export var ResponseEnum;
(function (ResponseEnum) {
    ResponseEnum[ResponseEnum["UNSPECIFIED_RESPONSE"] = 0] = "UNSPECIFIED_RESPONSE";
    ResponseEnum[ResponseEnum["GOOD"] = 1] = "GOOD";
    ResponseEnum[ResponseEnum["ERROR"] = 2] = "ERROR";
    ResponseEnum[ResponseEnum["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ResponseEnum || (ResponseEnum = {}));
export function responseEnumFromJSON(object) {
    switch (object) {
        case 0:
        case "UNSPECIFIED_RESPONSE":
            return ResponseEnum.UNSPECIFIED_RESPONSE;
        case 1:
        case "GOOD":
            return ResponseEnum.GOOD;
        case 2:
        case "ERROR":
            return ResponseEnum.ERROR;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ResponseEnum.UNRECOGNIZED;
    }
}
export function responseEnumToJSON(object) {
    switch (object) {
        case ResponseEnum.UNSPECIFIED_RESPONSE:
            return "UNSPECIFIED_RESPONSE";
        case ResponseEnum.GOOD:
            return "GOOD";
        case ResponseEnum.ERROR:
            return "ERROR";
        case ResponseEnum.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseApplicationMessage() {
    return { header: undefined, body: new Uint8Array(0), signature: new Uint8Array(0) };
}
export const ApplicationMessage = {
    encode(message, writer = new BinaryWriter()) {
        if (message.header !== undefined) {
            ApplicationMessageHeader.encode(message.header, writer.uint32(10).fork()).join();
        }
        if (message.body.length !== 0) {
            writer.uint32(18).bytes(message.body);
        }
        if (message.signature.length !== 0) {
            writer.uint32(26).bytes(message.signature);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseApplicationMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.header = ApplicationMessageHeader.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.body = reader.bytes();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.signature = reader.bytes();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            header: isSet(object.header) ? ApplicationMessageHeader.fromJSON(object.header) : undefined,
            body: isSet(object.body) ? bytesFromBase64(object.body) : new Uint8Array(0),
            signature: isSet(object.signature) ? bytesFromBase64(object.signature) : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.header !== undefined) {
            obj.header = ApplicationMessageHeader.toJSON(message.header);
        }
        if (message.body.length !== 0) {
            obj.body = base64FromBytes(message.body);
        }
        if (message.signature.length !== 0) {
            obj.signature = base64FromBytes(message.signature);
        }
        return obj;
    },
    create(base) {
        return ApplicationMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseApplicationMessage();
        message.header = (object.header !== undefined && object.header !== null)
            ? ApplicationMessageHeader.fromPartial(object.header)
            : undefined;
        message.body = object.body ?? new Uint8Array(0);
        message.signature = object.signature ?? new Uint8Array(0);
        return message;
    },
};
function createBaseApplicationMessageHeader() {
    return {
        subject: undefined,
        recipients: undefined,
        expires: 0,
        sender: "",
        qosProfile: undefined,
        bodySizeNumBytes: 0,
    };
}
export const ApplicationMessageHeader = {
    encode(message, writer = new BinaryWriter()) {
        if (message.subject !== undefined) {
            writer.uint32(10).string(message.subject);
        }
        if (message.recipients !== undefined) {
            Recipients.encode(message.recipients, writer.uint32(18).fork()).join();
        }
        if (message.expires !== 0) {
            writer.uint32(24).int64(message.expires);
        }
        if (message.sender !== "") {
            writer.uint32(34).string(message.sender);
        }
        if (message.qosProfile !== undefined) {
            writer.uint32(42).string(message.qosProfile);
        }
        if (message.bodySizeNumBytes !== 0) {
            writer.uint32(48).uint32(message.bodySizeNumBytes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseApplicationMessageHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.subject = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.recipients = Recipients.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.expires = longToNumber(reader.int64());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.sender = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.qosProfile = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.bodySizeNumBytes = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subject: isSet(object.subject) ? globalThis.String(object.subject) : undefined,
            recipients: isSet(object.recipients) ? Recipients.fromJSON(object.recipients) : undefined,
            expires: isSet(object.expires) ? globalThis.Number(object.expires) : 0,
            sender: isSet(object.sender) ? globalThis.String(object.sender) : "",
            qosProfile: isSet(object.qosProfile) ? globalThis.String(object.qosProfile) : undefined,
            bodySizeNumBytes: isSet(object.bodySizeNumBytes) ? globalThis.Number(object.bodySizeNumBytes) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subject !== undefined) {
            obj.subject = message.subject;
        }
        if (message.recipients !== undefined) {
            obj.recipients = Recipients.toJSON(message.recipients);
        }
        if (message.expires !== 0) {
            obj.expires = Math.round(message.expires);
        }
        if (message.sender !== "") {
            obj.sender = message.sender;
        }
        if (message.qosProfile !== undefined) {
            obj.qosProfile = message.qosProfile;
        }
        if (message.bodySizeNumBytes !== 0) {
            obj.bodySizeNumBytes = Math.round(message.bodySizeNumBytes);
        }
        return obj;
    },
    create(base) {
        return ApplicationMessageHeader.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseApplicationMessageHeader();
        message.subject = object.subject ?? undefined;
        message.recipients = (object.recipients !== undefined && object.recipients !== null)
            ? Recipients.fromPartial(object.recipients)
            : undefined;
        message.expires = object.expires ?? 0;
        message.sender = object.sender ?? "";
        message.qosProfile = object.qosProfile ?? undefined;
        message.bodySizeNumBytes = object.bodySizeNumBytes ?? 0;
        return message;
    },
};
function createBaseRecipients() {
    return { recipients: [] };
}
export const Recipients = {
    encode(message, writer = new BinaryWriter()) {
        for (const v of message.recipients) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRecipients();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.recipients.push(reader.string());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            recipients: globalThis.Array.isArray(object?.recipients)
                ? object.recipients.map((e) => globalThis.String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.recipients?.length) {
            obj.recipients = message.recipients;
        }
        return obj;
    },
    create(base) {
        return Recipients.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecipients();
        message.recipients = object.recipients?.map((e) => e) || [];
        return message;
    },
};
function createBaseMmtpMessage() {
    return { msgType: 0, uuid: "", protocolMessage: undefined, responseMessage: undefined };
}
export const MmtpMessage = {
    encode(message, writer = new BinaryWriter()) {
        if (message.msgType !== 0) {
            writer.uint32(8).int32(message.msgType);
        }
        if (message.uuid !== "") {
            writer.uint32(18).string(message.uuid);
        }
        if (message.protocolMessage !== undefined) {
            ProtocolMessage.encode(message.protocolMessage, writer.uint32(26).fork()).join();
        }
        if (message.responseMessage !== undefined) {
            ResponseMessage.encode(message.responseMessage, writer.uint32(34).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMmtpMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.msgType = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.uuid = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.protocolMessage = ProtocolMessage.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.responseMessage = ResponseMessage.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            msgType: isSet(object.msgType) ? msgTypeFromJSON(object.msgType) : 0,
            uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
            protocolMessage: isSet(object.protocolMessage) ? ProtocolMessage.fromJSON(object.protocolMessage) : undefined,
            responseMessage: isSet(object.responseMessage) ? ResponseMessage.fromJSON(object.responseMessage) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.msgType !== 0) {
            obj.msgType = msgTypeToJSON(message.msgType);
        }
        if (message.uuid !== "") {
            obj.uuid = message.uuid;
        }
        if (message.protocolMessage !== undefined) {
            obj.protocolMessage = ProtocolMessage.toJSON(message.protocolMessage);
        }
        if (message.responseMessage !== undefined) {
            obj.responseMessage = ResponseMessage.toJSON(message.responseMessage);
        }
        return obj;
    },
    create(base) {
        return MmtpMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMmtpMessage();
        message.msgType = object.msgType ?? 0;
        message.uuid = object.uuid ?? "";
        message.protocolMessage = (object.protocolMessage !== undefined && object.protocolMessage !== null)
            ? ProtocolMessage.fromPartial(object.protocolMessage)
            : undefined;
        message.responseMessage = (object.responseMessage !== undefined && object.responseMessage !== null)
            ? ResponseMessage.fromPartial(object.responseMessage)
            : undefined;
        return message;
    },
};
function createBaseProtocolMessage() {
    return {
        protocolMsgType: 0,
        subscribeMessage: undefined,
        unsubscribeMessage: undefined,
        sendMessage: undefined,
        receiveMessage: undefined,
        fetchMessage: undefined,
        disconnectMessage: undefined,
        connectMessage: undefined,
        notifyMessage: undefined,
    };
}
export const ProtocolMessage = {
    encode(message, writer = new BinaryWriter()) {
        if (message.protocolMsgType !== 0) {
            writer.uint32(8).int32(message.protocolMsgType);
        }
        if (message.subscribeMessage !== undefined) {
            Subscribe.encode(message.subscribeMessage, writer.uint32(18).fork()).join();
        }
        if (message.unsubscribeMessage !== undefined) {
            Unsubscribe.encode(message.unsubscribeMessage, writer.uint32(26).fork()).join();
        }
        if (message.sendMessage !== undefined) {
            Send.encode(message.sendMessage, writer.uint32(34).fork()).join();
        }
        if (message.receiveMessage !== undefined) {
            Receive.encode(message.receiveMessage, writer.uint32(42).fork()).join();
        }
        if (message.fetchMessage !== undefined) {
            Fetch.encode(message.fetchMessage, writer.uint32(50).fork()).join();
        }
        if (message.disconnectMessage !== undefined) {
            Disconnect.encode(message.disconnectMessage, writer.uint32(58).fork()).join();
        }
        if (message.connectMessage !== undefined) {
            Connect.encode(message.connectMessage, writer.uint32(66).fork()).join();
        }
        if (message.notifyMessage !== undefined) {
            Notify.encode(message.notifyMessage, writer.uint32(74).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProtocolMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.protocolMsgType = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.subscribeMessage = Subscribe.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.unsubscribeMessage = Unsubscribe.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.sendMessage = Send.decode(reader, reader.uint32());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.receiveMessage = Receive.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.fetchMessage = Fetch.decode(reader, reader.uint32());
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.disconnectMessage = Disconnect.decode(reader, reader.uint32());
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.connectMessage = Connect.decode(reader, reader.uint32());
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.notifyMessage = Notify.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            protocolMsgType: isSet(object.protocolMsgType) ? protocolMessageTypeFromJSON(object.protocolMsgType) : 0,
            subscribeMessage: isSet(object.subscribeMessage) ? Subscribe.fromJSON(object.subscribeMessage) : undefined,
            unsubscribeMessage: isSet(object.unsubscribeMessage)
                ? Unsubscribe.fromJSON(object.unsubscribeMessage)
                : undefined,
            sendMessage: isSet(object.sendMessage) ? Send.fromJSON(object.sendMessage) : undefined,
            receiveMessage: isSet(object.receiveMessage) ? Receive.fromJSON(object.receiveMessage) : undefined,
            fetchMessage: isSet(object.fetchMessage) ? Fetch.fromJSON(object.fetchMessage) : undefined,
            disconnectMessage: isSet(object.disconnectMessage) ? Disconnect.fromJSON(object.disconnectMessage) : undefined,
            connectMessage: isSet(object.connectMessage) ? Connect.fromJSON(object.connectMessage) : undefined,
            notifyMessage: isSet(object.notifyMessage) ? Notify.fromJSON(object.notifyMessage) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.protocolMsgType !== 0) {
            obj.protocolMsgType = protocolMessageTypeToJSON(message.protocolMsgType);
        }
        if (message.subscribeMessage !== undefined) {
            obj.subscribeMessage = Subscribe.toJSON(message.subscribeMessage);
        }
        if (message.unsubscribeMessage !== undefined) {
            obj.unsubscribeMessage = Unsubscribe.toJSON(message.unsubscribeMessage);
        }
        if (message.sendMessage !== undefined) {
            obj.sendMessage = Send.toJSON(message.sendMessage);
        }
        if (message.receiveMessage !== undefined) {
            obj.receiveMessage = Receive.toJSON(message.receiveMessage);
        }
        if (message.fetchMessage !== undefined) {
            obj.fetchMessage = Fetch.toJSON(message.fetchMessage);
        }
        if (message.disconnectMessage !== undefined) {
            obj.disconnectMessage = Disconnect.toJSON(message.disconnectMessage);
        }
        if (message.connectMessage !== undefined) {
            obj.connectMessage = Connect.toJSON(message.connectMessage);
        }
        if (message.notifyMessage !== undefined) {
            obj.notifyMessage = Notify.toJSON(message.notifyMessage);
        }
        return obj;
    },
    create(base) {
        return ProtocolMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProtocolMessage();
        message.protocolMsgType = object.protocolMsgType ?? 0;
        message.subscribeMessage = (object.subscribeMessage !== undefined && object.subscribeMessage !== null)
            ? Subscribe.fromPartial(object.subscribeMessage)
            : undefined;
        message.unsubscribeMessage = (object.unsubscribeMessage !== undefined && object.unsubscribeMessage !== null)
            ? Unsubscribe.fromPartial(object.unsubscribeMessage)
            : undefined;
        message.sendMessage = (object.sendMessage !== undefined && object.sendMessage !== null)
            ? Send.fromPartial(object.sendMessage)
            : undefined;
        message.receiveMessage = (object.receiveMessage !== undefined && object.receiveMessage !== null)
            ? Receive.fromPartial(object.receiveMessage)
            : undefined;
        message.fetchMessage = (object.fetchMessage !== undefined && object.fetchMessage !== null)
            ? Fetch.fromPartial(object.fetchMessage)
            : undefined;
        message.disconnectMessage = (object.disconnectMessage !== undefined && object.disconnectMessage !== null)
            ? Disconnect.fromPartial(object.disconnectMessage)
            : undefined;
        message.connectMessage = (object.connectMessage !== undefined && object.connectMessage !== null)
            ? Connect.fromPartial(object.connectMessage)
            : undefined;
        message.notifyMessage = (object.notifyMessage !== undefined && object.notifyMessage !== null)
            ? Notify.fromPartial(object.notifyMessage)
            : undefined;
        return message;
    },
};
function createBaseSubscribe() {
    return { subject: undefined, directMessages: undefined };
}
export const Subscribe = {
    encode(message, writer = new BinaryWriter()) {
        if (message.subject !== undefined) {
            writer.uint32(10).string(message.subject);
        }
        if (message.directMessages !== undefined) {
            writer.uint32(16).bool(message.directMessages);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscribe();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.subject = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.directMessages = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subject: isSet(object.subject) ? globalThis.String(object.subject) : undefined,
            directMessages: isSet(object.directMessages) ? globalThis.Boolean(object.directMessages) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subject !== undefined) {
            obj.subject = message.subject;
        }
        if (message.directMessages !== undefined) {
            obj.directMessages = message.directMessages;
        }
        return obj;
    },
    create(base) {
        return Subscribe.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscribe();
        message.subject = object.subject ?? undefined;
        message.directMessages = object.directMessages ?? undefined;
        return message;
    },
};
function createBaseUnsubscribe() {
    return { subject: undefined, directMessages: undefined };
}
export const Unsubscribe = {
    encode(message, writer = new BinaryWriter()) {
        if (message.subject !== undefined) {
            writer.uint32(10).string(message.subject);
        }
        if (message.directMessages !== undefined) {
            writer.uint32(16).bool(message.directMessages);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnsubscribe();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.subject = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.directMessages = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subject: isSet(object.subject) ? globalThis.String(object.subject) : undefined,
            directMessages: isSet(object.directMessages) ? globalThis.Boolean(object.directMessages) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subject !== undefined) {
            obj.subject = message.subject;
        }
        if (message.directMessages !== undefined) {
            obj.directMessages = message.directMessages;
        }
        return obj;
    },
    create(base) {
        return Unsubscribe.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnsubscribe();
        message.subject = object.subject ?? undefined;
        message.directMessages = object.directMessages ?? undefined;
        return message;
    },
};
function createBaseSend() {
    return { applicationMessage: undefined };
}
export const Send = {
    encode(message, writer = new BinaryWriter()) {
        if (message.applicationMessage !== undefined) {
            ApplicationMessage.encode(message.applicationMessage, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSend();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.applicationMessage = ApplicationMessage.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            applicationMessage: isSet(object.applicationMessage)
                ? ApplicationMessage.fromJSON(object.applicationMessage)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.applicationMessage !== undefined) {
            obj.applicationMessage = ApplicationMessage.toJSON(message.applicationMessage);
        }
        return obj;
    },
    create(base) {
        return Send.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSend();
        message.applicationMessage = (object.applicationMessage !== undefined && object.applicationMessage !== null)
            ? ApplicationMessage.fromPartial(object.applicationMessage)
            : undefined;
        return message;
    },
};
function createBaseReceive() {
    return { filter: undefined };
}
export const Receive = {
    encode(message, writer = new BinaryWriter()) {
        if (message.filter !== undefined) {
            Filter.encode(message.filter, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReceive();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.filter = Filter.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { filter: isSet(object.filter) ? Filter.fromJSON(object.filter) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.filter !== undefined) {
            obj.filter = Filter.toJSON(message.filter);
        }
        return obj;
    },
    create(base) {
        return Receive.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReceive();
        message.filter = (object.filter !== undefined && object.filter !== null)
            ? Filter.fromPartial(object.filter)
            : undefined;
        return message;
    },
};
function createBaseFilter() {
    return { messageUuids: [] };
}
export const Filter = {
    encode(message, writer = new BinaryWriter()) {
        for (const v of message.messageUuids) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.messageUuids.push(reader.string());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            messageUuids: globalThis.Array.isArray(object?.messageUuids)
                ? object.messageUuids.map((e) => globalThis.String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.messageUuids?.length) {
            obj.messageUuids = message.messageUuids;
        }
        return obj;
    },
    create(base) {
        return Filter.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFilter();
        message.messageUuids = object.messageUuids?.map((e) => e) || [];
        return message;
    },
};
function createBaseFetch() {
    return {};
}
export const Fetch = {
    encode(_, writer = new BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFetch();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Fetch.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseFetch();
        return message;
    },
};
function createBaseDisconnect() {
    return {};
}
export const Disconnect = {
    encode(_, writer = new BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDisconnect();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Disconnect.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDisconnect();
        return message;
    },
};
function createBaseConnect() {
    return { ownMrn: undefined, reconnectToken: undefined };
}
export const Connect = {
    encode(message, writer = new BinaryWriter()) {
        if (message.ownMrn !== undefined) {
            writer.uint32(10).string(message.ownMrn);
        }
        if (message.reconnectToken !== undefined) {
            writer.uint32(18).string(message.reconnectToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConnect();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.ownMrn = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.reconnectToken = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            ownMrn: isSet(object.ownMrn) ? globalThis.String(object.ownMrn) : undefined,
            reconnectToken: isSet(object.reconnectToken) ? globalThis.String(object.reconnectToken) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ownMrn !== undefined) {
            obj.ownMrn = message.ownMrn;
        }
        if (message.reconnectToken !== undefined) {
            obj.reconnectToken = message.reconnectToken;
        }
        return obj;
    },
    create(base) {
        return Connect.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConnect();
        message.ownMrn = object.ownMrn ?? undefined;
        message.reconnectToken = object.reconnectToken ?? undefined;
        return message;
    },
};
function createBaseNotify() {
    return { messageMetadata: [] };
}
export const Notify = {
    encode(message, writer = new BinaryWriter()) {
        for (const v of message.messageMetadata) {
            MessageMetadata.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseNotify();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.messageMetadata.push(MessageMetadata.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            messageMetadata: globalThis.Array.isArray(object?.messageMetadata)
                ? object.messageMetadata.map((e) => MessageMetadata.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.messageMetadata?.length) {
            obj.messageMetadata = message.messageMetadata.map((e) => MessageMetadata.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return Notify.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseNotify();
        message.messageMetadata = object.messageMetadata?.map((e) => MessageMetadata.fromPartial(e)) || [];
        return message;
    },
};
function createBaseResponseMessage() {
    return {
        responseToUuid: "",
        response: 0,
        reasonText: undefined,
        messageMetadata: [],
        messageContent: [],
        reconnectToken: undefined,
    };
}
export const ResponseMessage = {
    encode(message, writer = new BinaryWriter()) {
        if (message.responseToUuid !== "") {
            writer.uint32(10).string(message.responseToUuid);
        }
        if (message.response !== 0) {
            writer.uint32(16).int32(message.response);
        }
        if (message.reasonText !== undefined) {
            writer.uint32(26).string(message.reasonText);
        }
        for (const v of message.messageMetadata) {
            MessageMetadata.encode(v, writer.uint32(34).fork()).join();
        }
        for (const v of message.messageContent) {
            MessageContent.encode(v, writer.uint32(42).fork()).join();
        }
        if (message.reconnectToken !== undefined) {
            writer.uint32(50).string(message.reconnectToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.responseToUuid = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.response = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.reasonText = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.messageMetadata.push(MessageMetadata.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.messageContent.push(MessageContent.decode(reader, reader.uint32()));
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.reconnectToken = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            responseToUuid: isSet(object.responseToUuid) ? globalThis.String(object.responseToUuid) : "",
            response: isSet(object.response) ? responseEnumFromJSON(object.response) : 0,
            reasonText: isSet(object.reasonText) ? globalThis.String(object.reasonText) : undefined,
            messageMetadata: globalThis.Array.isArray(object?.messageMetadata)
                ? object.messageMetadata.map((e) => MessageMetadata.fromJSON(e))
                : [],
            messageContent: globalThis.Array.isArray(object?.messageContent)
                ? object.messageContent.map((e) => MessageContent.fromJSON(e))
                : [],
            reconnectToken: isSet(object.reconnectToken) ? globalThis.String(object.reconnectToken) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.responseToUuid !== "") {
            obj.responseToUuid = message.responseToUuid;
        }
        if (message.response !== 0) {
            obj.response = responseEnumToJSON(message.response);
        }
        if (message.reasonText !== undefined) {
            obj.reasonText = message.reasonText;
        }
        if (message.messageMetadata?.length) {
            obj.messageMetadata = message.messageMetadata.map((e) => MessageMetadata.toJSON(e));
        }
        if (message.messageContent?.length) {
            obj.messageContent = message.messageContent.map((e) => MessageContent.toJSON(e));
        }
        if (message.reconnectToken !== undefined) {
            obj.reconnectToken = message.reconnectToken;
        }
        return obj;
    },
    create(base) {
        return ResponseMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseResponseMessage();
        message.responseToUuid = object.responseToUuid ?? "";
        message.response = object.response ?? 0;
        message.reasonText = object.reasonText ?? undefined;
        message.messageMetadata = object.messageMetadata?.map((e) => MessageMetadata.fromPartial(e)) || [];
        message.messageContent = object.messageContent?.map((e) => MessageContent.fromPartial(e)) || [];
        message.reconnectToken = object.reconnectToken ?? undefined;
        return message;
    },
};
function createBaseMessageMetadata() {
    return { uuid: "", header: undefined };
}
export const MessageMetadata = {
    encode(message, writer = new BinaryWriter()) {
        if (message.uuid !== "") {
            writer.uint32(10).string(message.uuid);
        }
        if (message.header !== undefined) {
            ApplicationMessageHeader.encode(message.header, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMessageMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.uuid = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.header = ApplicationMessageHeader.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
            header: isSet(object.header) ? ApplicationMessageHeader.fromJSON(object.header) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.uuid !== "") {
            obj.uuid = message.uuid;
        }
        if (message.header !== undefined) {
            obj.header = ApplicationMessageHeader.toJSON(message.header);
        }
        return obj;
    },
    create(base) {
        return MessageMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMessageMetadata();
        message.uuid = object.uuid ?? "";
        message.header = (object.header !== undefined && object.header !== null)
            ? ApplicationMessageHeader.fromPartial(object.header)
            : undefined;
        return message;
    },
};
function createBaseMessageContent() {
    return { uuid: "", msg: undefined };
}
export const MessageContent = {
    encode(message, writer = new BinaryWriter()) {
        if (message.uuid !== "") {
            writer.uint32(10).string(message.uuid);
        }
        if (message.msg !== undefined) {
            ApplicationMessage.encode(message.msg, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMessageContent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.uuid = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.msg = ApplicationMessage.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
            msg: isSet(object.msg) ? ApplicationMessage.fromJSON(object.msg) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.uuid !== "") {
            obj.uuid = message.uuid;
        }
        if (message.msg !== undefined) {
            obj.msg = ApplicationMessage.toJSON(message.msg);
        }
        return obj;
    },
    create(base) {
        return MessageContent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMessageContent();
        message.uuid = object.uuid ?? "";
        message.msg = (object.msg !== undefined && object.msg !== null)
            ? ApplicationMessage.fromPartial(object.msg)
            : undefined;
        return message;
    },
};
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(globalThis.String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
function longToNumber(int64) {
    const num = globalThis.Number(int64.toString());
    if (num > globalThis.Number.MAX_SAFE_INTEGER) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (num < globalThis.Number.MIN_SAFE_INTEGER) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return num;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
